export var name = 'tournamentsList';
